<template>
  <div>
    <el-upload
        action="#"
        :http-request="uploadFile"
         list-type="picture-card"
         :show-file-list="false"
        :multiple="multiple"
        ref="upload"
        accept='.jpg, .jpeg, .png, .gif'
        :before-upload="beforeUpload"
        >
     
         <img v-if="imageUrl"  class="file-img" style="height: 100%;width: 100%" :src="imageUrl" />
          <i v-else class="el-icon-plus "></i>
     
    </el-upload>
  </div>
</template>

<script>
import axios from 'axios';
import {CacheService} from "@/service/common";

export default {
  props:{
    multiple:{
      type:Boolean,
      default:true
    },
    funcName:{
      type:String,
      default:"PayRefund"
    },
      imageUrl: String,
  },
  data() {
    return {
      baseURL: this.$fileBaseUrl,
      imgList: [],
      urlList: [],
      saveUrls:[],
      compId:CacheService.get("comp").compId,
    }
  },
  methods: {
    clear(){
      this.imgList.length=0;
      this.urlList.length=0;
      this.saveUrls.length=0;
    },
  
    uploadFile(param) {
      const formdata = new FormData()
      formdata.append('file', param.file)
    
      let fileExt1 = param.file.name.substring(param.file.name.lastIndexOf("."));
      let fileExt2 = param.file.name.substring(param.file.name.lastIndexOf(".") + 1);
      let url = `/Yunos/File/MinioUploadURL?fileExt=${fileExt2}&funcName=${this.funcName}`;
      this.$axios.get(url).then((message) => {
        if (message) {
          this.$uaxios.put(message.uploadPath,
              param.file).then((res) => {
            if (res.status === 200) {
              res.filePath = message.filePath;
              res.fileName = param.file.name;
              res.fileExt = fileExt1;
              param.onSuccess(res);
               this.$emit('success','https://zrpcode.oss.maidiyun.cn/' + res.filePath)
            } else {
              param.onError();
            }
          }, (err) => {
            param.onError(err);
          })
        }
      })
    },
    beforeUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      const isImage = types.includes(file.type);
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG、GIF 格式!');
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.warning("文件大小不能超过5M!");
        return false
      }
    },   
  }
}
</script>

<style scoped lang="scss">


img {
  width: 105px;
  height: 105px;
}
.img-btn {
  height: 30px;
  background-color: #7B7B7B;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  display: none;
  opacity: 0.9;


}



</style>
